module.exports = __webpack_public_path__ + "images/stickers/pete-talk.c0b6f3f95505b6d0883d.png";